/**
 * Return link summary
 */
export var extractSummary = function extractSummary(jsonLd) {
  if (typeof (jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.summary) === 'string') {
    var summary = jsonLd.summary.trim();
    return Boolean(summary) ? summary : undefined;
  }
};